// Module
var code = "<react-component name=\"ContactNotesReport\"></react-component>\n";
// Exports
module.exports = code;